export default {
  title: 'ポイントモール設定',
  productConfig: '商品設定',
};
